// extracted by mini-css-extract-plugin
module.exports = {"reservationButton":"ReservationButton_reservationButton__v0hYO","disabled":"ReservationButton_disabled__gGWB3"};